import React from 'react'
import { useIntl } from 'react-intl'
import styled from '@emotion/styled'
import { H3 } from '../../../../layouts/TextStyles'
import CourseProgressCard from './components/CourseProgressCard'
import { ui } from '../../../../utils/uiTokens'

const CoursesProgressPage = () => {
    const { formatMessage } = useIntl()

    return (
        <Wrapper>
            <Content>
                <Header>
                    <Title>
                        <H3>{formatMessage({ id: 'courses' })}</H3>
                    </Title>
                </Header>

                {/* {isFetching && <LinearProgress />} */}
                <CourseProgressCard />
                <CourseProgressCard />
                <CourseProgressCard />
                <CourseProgressCard />
            </Content>
        </Wrapper>
    )
}

export default CoursesProgressPage

const Wrapper = styled.div`
    margin: 10px;
    border-radius: 16px;
`
const Title = styled.div`
    margin-bottom: 20px;
    text-align: left;
    display: flex;
    align-items: center;
`

const Content = styled.div`
    background-color: ${ui.card};
    border-radius: 16px;
    padding: 20px;
    min-height: 80vh;
`

const Header = styled.header`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
`
